import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoWal: CultureInfo = {
  name: 'wal',
  displayName: 'ወላይታቱ',
  iso3LanguageCode: 'wal',
  iso2LanguageCode: 'wal',
  ietfLanguageTag: 'wal',
  parent: null
};
